import { Tooltip } from "@mui/material";
import { ReactNode } from "react";
interface MaintenanceTooltipProps {
  message: string;
  children: ReactNode;
  disableHover: boolean;
}

const MaintananceTooltip = ({ message, children, disableHover }: MaintenanceTooltipProps) => {
  return (
    <Tooltip
      arrow
      title={
        <div
          style={{
            fontSize: "14px",
            color: "#F8F9F9",
            margin: "2px",
            alignItems: "center",
          }}>
          {message}
        </div>
      }
      disableHoverListener={disableHover}
      componentsProps={{
        tooltip: {
          sx: { color: "#324E61", backgroundColor: "#324E61", opacity: 0.8 },
        },
      }}>
      <span style={{ cursor: !disableHover ? "not-allowed" : "pointer" }}>{children}</span>
    </Tooltip>
  );
};

export default MaintananceTooltip;
